// ============================================================================
// UNIVERSAL ACTION HANDLERS - ENTITY-SPECIFIC ACTIONS
// ============================================================================

import type { UniversalActionHandlers } from "./types";
import { miscEntityActions } from "./entity-actions-misc";
import { dealActions } from "./entity-actions-deals";

/**
 * Entity-Specific Actions
 */
export const entitySpecificActions: UniversalActionHandlers = {
  ...miscEntityActions,
  ...dealActions,
};
